import { Box, BoxProps, Text } from '@chakra-ui/react';

interface EmptyProps extends BoxProps {
  message: string;
}

export function Empty({ message, ...props }: EmptyProps) {
  return (
    <Box py="64px" {...props}>
      <Text
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="text.faint"
        mb="12px"
      >
        sem resultados
      </Text>
      <Text fontFamily="display" fontSize="32px" color="text.primary">
        {message}
      </Text>
    </Box>
  );
}
